import React from "react";
import { Row, Col } from 'react-bootstrap';
import { ISectionData } from "../../types/api/aboutApi";
import { NoData } from "../common/NoData";
import { useTranslation } from "react-i18next";
import { IAboutUsDetails } from "../../types/features/multiLanguageSlice";

const AboutSection: React.FC<{ details: Array<ISectionData> }> = ({ details }) => {
const {t} = useTranslation()
const details_json = t('about_us.details', { returnObjects: true })  as IAboutUsDetails[];

    if (details && details.length) {
        return (
            <div>
                <div>
                    <section className='about-section'>
                        <div className="container">
                            <Row className="d-flex">
                                <Col md={12} lg={6} className="p-0 d-flex align-items-stretch">
                                    <div className="about-img">
                                        <img src={details['0'].image} alt="img" className="img-fluid" />
                                    </div>
                                </Col>
                                <Col md={12} lg={6} className="p-0 d-flex align-items-stretch">
                                    <div className="about-content">
                                        <h3 className="title">{details_json['0'].name}</h3>
                                        <p className="text">{details_json['0'].description}</p>
                                    </div>
                                </Col>
                            </Row>
                            <Row className="right-content d-flex">
                                <Col md={12} lg={6} className="p-0 d-flex align-items-stretch">
                                    <div className="about-content">
                                        <h3 className="title">{details_json['0'].name}</h3>
                                        <p className="text">{details_json['0'].description}</p>
                                    </div>
                                </Col>
                                <Col md={12} lg={6} className="p-0 d-flex align-items-stretch">
                                    <div className="about-img">
                                        <img src={details['0'].image} alt="img" className="img-fluid" />
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </section>
                </div>

            </div>
        );
    }
    return <NoData message="Oops, No Data For AboutUs!!" />
}
export default AboutSection;